import React from 'react';
import { motion } from 'framer-motion';
export function ReframeSection() {
  return <section className="py-20 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-119">
      {/* Background texture/pattern could go here */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-120">
        <div className="absolute right-0 top-0 w-1/2 h-full bg-gradient-to-l from-brand-terracotta to-transparent" data-id="element-121"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-123">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-gold mb-6" data-id="element-124">
            No es falta de voluntad. Es una caída de estrógenos.
          </h2>
          <p className="font-sans text-lg md:text-xl leading-relaxed text-brand-cream/90" data-id="element-125">
            Lo que estás viviendo es el inicio de una{' '}
            <span className="font-bold text-white" data-id="element-126">
              transición metabólica profunda
            </span>{' '}
            que el sistema de salud español tradicionalmente ignora.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6 font-sans text-brand-cream/80" data-id="element-128">
            <p data-id="element-129">
              Tus hormonas han cambiado las reglas del juego. Si sigues usando
              las reglas de cuando tenías 20 años (comer menos y moverte más),
              solo conseguirás estresar más a tu cuerpo y ganar más grasa
              abdominal.
            </p>
            <p data-id="element-130">
              El cortisol (hormona del estrés) está secuestrando tu
              progesterona. Tu insulina ya no gestiona los carbohidratos igual.
              Tu tiroides está pidiendo auxilio.
            </p>
            <div className="p-6 border-l-4 border-brand-terracotta bg-white/5 rounded-r-lg" data-id="element-131">
              <p className="font-serif italic text-white text-lg" data-id="element-132">
                "Necesitas dejar de luchar contra tu cuerpo y empezar a trabajar
                CON tu nueva biología."
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-cream text-brand-dark p-8 rounded-xl shadow-2xl transform md:rotate-2" data-id="element-133">
            <h3 className="font-serif text-2xl font-bold mb-4 text-brand-terracotta" data-id="element-134">
              La Solución: Nutrición Circadiana
            </h3>
            <ul className="space-y-4" data-id="element-135">
              <li className="flex items-start" data-id="element-136">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-sage text-white flex items-center justify-center text-sm font-bold mr-3 mt-0.5" data-id="element-137">
                  1
                </span>
                <span data-id="element-138">Sincronizar tu alimentación con tu reloj biológico.</span>
              </li>
              <li className="flex items-start" data-id="element-139">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-sage text-white flex items-center justify-center text-sm font-bold mr-3 mt-0.5" data-id="element-140">
                  2
                </span>
                <span data-id="element-141">Apagar la inflamación celular silenciosa.</span>
              </li>
              <li className="flex items-start" data-id="element-142">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-sage text-white flex items-center justify-center text-sm font-bold mr-3 mt-0.5" data-id="element-143">
                  3
                </span>
                <span data-id="element-144">Optimizar la desintoxicación de estrógenos.</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}